import { createRoutine } from 'redux-saga-routines';
export const rawDataCalculation = createRoutine<
  SimplePayloadCreator,
  SimplePayloadCreator,
  SimplePayloadCreator, // success
  SimplePayloadCreator,
  SimplePayloadCreator
>('@/pages/CompanyReport/rawDataCalculation', {});
